module.exports = __webpack_public_path__ + "static/sds-556b46f1f4e404c854201f89611397de.png";